import instance from "./request";

// 客服接口获取地址
export const getKefuUrlApi = (): DataAPI<any> =>
  instance.get("/shopping-backend/api/kefu/get-url");

export const getNoticeUnreadNumApi = (data: any): DataAPI<any> =>
  instance.get("/shopping-backend/api/notice/UnreadNum", data);

// 数据初始化csttest
export const getNewInitApi = (): DataAPI<any> =>
  instance.get("/auth/system/user/getCurrent");
// 导出一个函数getInitApi，用于获取当前用户的测试数据
// export const getNewInitApi = (): DataAPI<any> =>
//   // 使用instance.get方法，发送GET请求，获取当前用户的测试数据
//   instance.get("/auth/system/user/getCurrentTest");

// 打印订单接口
export const getDeliveryDataListApi = (data: string[]): DataAPI<any> =>
  instance.post("/shopping-backend/api/order/delivery/data-list", data);
/**
 * 获取菜单
 * system 0 全部 1后台 2小程序
 */
export const getMenu = (type = 0, id = 0, system = 1): DataAPI<any> =>
  instance.get(
    `/auth/system/menu/list?objectType=${type}&merchantId=${id}&menuSystem=${system}`
  );
/**
 * 添加菜单
 */
export const menuAdd = (data: any): DataAPI<any> =>
  instance.post("/auth/system/menu/add", data);
/**
 * 提交登录
 * @param data 登录参数
 */
export const submitUserLogin = (data: any): DataAPI<any> =>
  instance.post("/auth/system/login", data);
/**
 *获取登录信息
 */
export const getLoginInfo = (): DataAPI<any> =>
  instance.get("/shopping-backend/api/login/info");
/**
 * 获取首页菜单数据
 * @param data {Object} 参数 userId, objectType, organizeId, merchantId
 */
export const getNewMenus = (data: any): DataAPI<any> =>
  instance.post("/auth/system/user/getMenus", data);
// export const getNewMenus = (data: any): DataAPI<any> =>
//   instance.post("/auth/system/user/getMenusTest", data);
/**
 * 发送验证码
 * @param data {object} 参数 { mobile: '账号’ }
 */
export const sendCaptcha = (data: any): DataAPI<any> =>
  instance.post("/auth/system/user/messageSend", data);
/**
 *
 * @param data {object} 重置密码参数 { mobile， code， newPassword }
 */

export const resetPassword = (data: any): DataAPI<any> =>
  instance.post("/auth/system/user/passwordReset", data);
/**
 * 企业有效期校验
 * @param id {number} 企业id
 */
export const checkCompany = (id: number): DataAPI<any> =>
  instance.get(`/auth/system/user/companyCheck?merchantId=${id}`);

// 组织机构目录树
export const organizationTreeApi = (params:any): DataAPI<any> =>
  instance.get(`/auth/system/organization/tree`,{params});

// 修改组织状态接口
export const organizationChangeApi = (data: {
  id: string;
  status: number;
  type: number;
}): DataAPI<any> => instance.post("/auth/system/organization/change", data);

// 获取地理位置
export const regionTree = (): DataAPI<any> =>
  instance.get("/shopping-backend/api/region/el-tree");
/**
 * 退出登录
 *
 */
export const logout = (): DataAPI<any> => instance.get("/auth/system/logout");

// 新增门店
export const organizationEditStore = (
  data: organizationEditStore
): DataAPI<any> => instance.post("/auth/system/organization/edit-store", data);

// 新增角色或者编辑
export const roleSave = (data: roleSave): DataAPI<any> =>
  instance.post("/auth/system/role/save", data);

// 更改角色状态
export const roleChangeStatus = (data: any): DataAPI<any> =>
  instance.post("/auth/system/role/changeStatus", data);

// 更改角色状态
export const userChangeStatus = (data: any): DataAPI<any> =>
  instance.post("/auth/system/user/changeStatus", data);

// 查询角色对应菜单
export const roleGetMenus = (data: any): DataAPI<any> =>
  instance.post("/auth/system/role/getMenus", data);

// 查询角色菜单对应按钮
export const getButtons = (data: getButtons): DataAPI<any> =>
  instance.post("/auth/system/role/getButtons", data);

// 检查用户手机号是否注册
export const checkMobile = (data: any): DataAPI<any> =>
  instance.post("/auth/system/user/checkMobile", data);

// 平台新增用户或者编辑
export const userSave = (data: any): DataAPI<any> =>
  instance.post("/auth/system/user/save", data);

// 角色列表
export const roleList = (data: any): DataAPI<any> =>
  instance.post("/auth/system/user/getRoles", data);

// 新增用户并授权角色
export const saveByRole = (data: any): DataAPI<any> =>
  instance.post("/auth/system/user/saveByRole", data);
/**
 * 更改菜单状态
 */
export const changeMenuStatus = (data: any): DataAPI<any> =>
  instance.post("/auth/system/menu/changeStatus", data);

/**
 * 按ID获取菜单
 */
export const getMenuItem = (id: number | string): DataAPI<any> =>
  instance.get(`/auth/system/menu/get?id=${id}`);

// 编辑门店
export const editStore = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/organization/edit-store`, data);

// 查询门店详情
export const getStore = (id: any): DataAPI<any> =>
  instance.get(`/auth/system/organization/get-store?id=${id}`);

// 编辑企业
export const editMerchant = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/organization/edit-merchant`, data);

// 查询企业详情
export const getMerchant = (id: any): DataAPI<any> =>
  instance.get(`/auth/system/organization/get-merchant?id=${id}`);

// 编辑品牌店
export const editShoppe = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/organization/edit-shoppe`, data);

// 查询品牌店详情
export const getShoppe = (id: any): DataAPI<any> =>
  instance.get(`/auth/system/organization/get-shoppe?id=${id}`);

// 获取授权详情
export const getLicensed = (id: any): DataAPI<any> =>
  instance.get(`/auth/system/organization/get-licensed?id=${id}`);

// 修改授权日期
export const cahngeOrganization = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/organization/update-licensed`, data);

// 获取用户角色关联的组织id
export const getOrgRoles = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/users/getOrgRoles`, data);

// 用户点击组织获取角色
export const getRolesByOrg = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/users/getRolesByOrg`, data);

// 用户授权角色
export const getSaveByRole = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/users/saveByRole`, data);

// 更改用户状态
export const changeStatus = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/users/changeStatus`, data);

// [商城]获取柜组列表
export const brandList = (merchantId: number): DataAPI<any> =>
  instance.get(`/open-api/brand/list-brand?merchantId=${merchantId}`);

// 用户授权企业柜组
export const userBrand = (merchantId: number, userId: number): DataAPI<any> =>
  instance.get(
    `/auth/system/user/getUserBrand?merchantId=${merchantId}&userId=${userId}`
  );

// 用户授权企业柜组
export const saveByBrand = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/user/saveByBrand`, data);

// [商城]获取业态/分类列表
export const categoryList = (merchantId: number): DataAPI<any> =>
  instance.get(`/open-api/category/list-category?merchantId=${merchantId}`);

// 获取用户类别
export const UserCategory = (
  merchantId: number,
  userId: number | string
): DataAPI<any> =>
  instance.get(
    `/auth/system/user/getUserCategory?merchantId=${merchantId}&userId=${userId}`
  );

// 用户授权企业类别
export const saveByCategory = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/user/saveByCategory`, data);

// 创建企业模式
export const modelAdd = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/model/add`, data);

// 删除企业模式
export const modelDelete = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/model/delete`, data);

// 按id查询企业模式
export const getModel = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/model/get`, data);

// 新增或编辑服务商
export const providerAdd = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/provider/add`, data);

// 按id查询服务商
export const getProvider = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/provider/get`, data);

// 门店商圈查询
export const getStoreDistrict = (storeId: any): DataAPI<any> =>
  instance.get(
    `/auth/system/organization/get-store-business-district?storeId=${storeId}`
  );

// 门店商圈设置
export const setStoreDistrict = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/organization/set-store-business-district`, data);

// 门店商圈删除
export const delStoreDistrict = (storeId: any): DataAPI<any> =>
  instance.get(
    `/auth/system/organization/delete-store-business-district?storeId=${storeId}`
  );
// 新增公共菜单或者编辑
export const menuCommonAdd = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/menu/common/add`, data);

// 新增公共菜单或者编辑
export const menuCommonDelete = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/menu/common/delete`, data);

// 门店列表
export const storeList = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/organization/list-store`, data);

// 用户列表
export const getUserList = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/users/list/all`, data);

// 获取业态
export const getFormat = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/shoppe/format`, data);

// 根据企业id和业态id获取当前业态下所有中分类
export const getMidCategory = (
  merchantId: number,
  industryCategoryId: number
): DataAPI<any> =>
  instance.get(
    `/shopping-backend/api/goods/category/getMidCategory?merchantId=${merchantId}&industryCategoryId=${industryCategoryId}`
  );

// 获取父级下的子分类
export const getCategory = (data: any): DataAPI<any> =>
  instance.get("/shopping-backend/openapi/goods/category/getChildCategory", {
    params: data,
  });

// 新增柜组
export const saveShoppe = (data: any): DataAPI<any> =>
  instance.post("/auth/system/shoppe/save", data);

// 更改柜组状态
export const changeShoppeStatus = (data: any): DataAPI<any> =>
  instance.post("/auth/system/shoppe/changeStatus", data);

// 按id获取柜组
export const getShoppeSystem = (id: any): DataAPI<any> =>
  instance.get(`/auth/system/shoppe/get?id=${id}`);

// 柜组上线门店
export const shoppeStoreOnline = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/shoppe/store/online`, data);

// 更改柜组用户上线门店
export const shoppeUserChangeStore = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/shoppe/user/changeStore`, data);

// 柜组用户上线门店
export const shoppeUserStoreList = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/shoppe/user/storeList`, data);

// 柜组审核
export const shoppeApproval = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/shoppe/approval`, data);
// 获取年龄段
export const getAge = (merchantId: any, shoppeId: any): DataAPI<any> =>
  instance.get(
    `/c-api/definition/draw-get?merchantId=${merchantId}&shoppeId=${shoppeId}`
  );
// 校验是否客服
export const kefuCheck = (id: any): DataAPI<any> =>
  instance.get(`/kefu-svc/check?id=${id}`);

// 商品分类列表
export const getCategoryListApi = (data: any): DataAPI<any> =>
  instance.get(`/shopping-backend/api/goods/category/el-tree`, data);

// 新增/编辑线下分类
export const addCategoryApi = (data: any): DataAPI<any> =>
  instance.post(`/auth/api/offline/edit`, data);

// 查询线下分类接口
export const getCategoryApi = (data: any): DataAPI<any> =>
  instance.get(
    `/auth/api/offline/list?merchantId=${data.merchantId}&id=${data.id}`
  );

// 线下分类点击编辑数据回显
export const getOnlineCategoryApi = (id: any): DataAPI<any> =>
  instance.get(`/auth/api/offline/list-online?offlineId=${id}`);

// 删除线下分类接口
export const deleteCategoryApi = (id: any): DataAPI<any> =>
  instance.post(`/auth/api/offline/delete?id=${id}`);

// 获取全部线下业态
export const getOfflineAll = (data: any): DataAPI<any> =>
  instance.get(`/auth/api/offline/list`, { params: data });

// 用户授权线下业态
export const saveByOfflineType = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/user/saveByOfflineType`, data);

// 获取用户线下业态
export const getUserOffline = (data: any): DataAPI<any> =>
  instance.get(`/auth/system/user/getUserOfflineType`, { params: data });

// 门店类型新增
export const saveCate = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/store/cate/save`, data);

// 删除门店类型
export const deleteCate = (data: any): DataAPI<any> =>
  instance.get(`/auth/system/store/cate/delete`, { params: data });

// 门店类型列表
export const storeCateList = (data: any): DataAPI<any> =>
  instance.post(`/auth/system/store/cate/list`, data);

// 获取商品分类模板的启用业态列表
export const goodsCategoryTemplate = (): DataAPI<any> =>
  instance.get(`/shopping-backend/openapi/goodsCategoryTemplate/list`);

// 根据企业id获取分类模板中选择了哪些业态
export const getIndustryList = (id: number): DataAPI<any> =>
  instance.get(
    `/shopping-backend/openapi/goods/category/getIndustryList?merchantId=${id}`
  );

// 获取业态下大分类和中分类树形列表
export const getBigAndMidListByInduId = (data: any): DataAPI<any> =>
  instance.get(
    `/shopping-backend/openapi/goods/category/getBigAndMidListByInduId`,
    { params: data }
  );

// 根据parentIds获取商品分类列表
export const getChildCategory = (data: any): DataAPI<any> =>
  instance.get(`/shopping-backend/openapi/goods/category/getChildCategory`, {
    params: data,
  });

export const getSystemUser = (): DataAPI<any> =>
  instance.get("/shopping-backend/api/syscurrUser/get");

// 财务流水账单
export const financeSettlementVoucher = (data: any): DataAPI<any> =>
  instance.post(
    "/shopping-backend/api/financeSettlement/financeSettlementVoucher",
    data
  );

// 用户门店保存
export const saveStoreListformat = (data: any): DataAPI<any> =>
  instance.post("/auth/system/store/listformat/save", data);

// 用户柜组保存
export const saveShoppeListformat = (data: any): DataAPI<any> =>
  instance.post("/auth/system/shoppe/listformat/save", data);

// 更改菜单排序
export const changeSortSave = (data: sortList[]): DataAPI<any> =>
  instance.post("/auth/system/menu/changeSort", data);

// 用户模板下载
export const getUserDown = (): DataAPI<any> =>
  instance.get("/auth/system/file/user/down", { data: { dataType: true } });

// 用户模板下载
export const getYuGouDeliverTime = (id: any): DataAPI<any> =>
  instance.get(`/shopping-backend/api/order/getYuGouDeliverTime?orderId=${id}`);

//地址转换经纬度
export const addressCode = (address: any): DataAPI<any> =>
  instance.get(`/auth/system/getTencentMap/getAddress?address=${address}`);

// 获取企业支付通道设置
export const getPayMethod = (id: number): DataAPI<any> =>
  instance.get(`/shopping-backend/api/merchant/pay-method/${id}`);

// 支付通道修改前验证
export const checkPayMethod = (data: any): DataAPI<any> =>
  instance.post(`/shopping-backend/api/merchant/pay-method/update/check`, data);

// 发送企业管理员短信验证码
export const getCode = (mobile: string): DataAPI<any> =>
  instance.get(`/shopping-backend/api/merchant/pay-method/send/code/${mobile}`);

// 修改支付通道
export const updatePayMethod = (data: any): DataAPI<any> =>
  instance.post(`/shopping-backend/api/merchant/pay-method/update`, data);

// 获取企业列表
export const merchantListApi = (): DataAPI<any> =>
  instance.get(`/shopping-backend/api/merchant/list`);

// 获取所属行业列表
export const qualificationApi = (type: number): DataAPI<any> =>
  instance.get(
    `/shopping-backend/api/merchant/wx-pay/applyment/qualification/list/${type}`
  );

// 获取人员证件类型
export const identityTypeApi = (): DataAPI<any> =>
  instance.get(
    `/shopping-backend/api/merchant/wx-pay/applyment/identity-type/list`
  );

// 获取状态类型列表
export const applymentStatusApi = (): DataAPI<any> =>
  instance.get(`/shopping-backend/api/merchant/wx-pay/applyment/status/list`);

// 获取登记类型列表
export const applymentCertApi = (): DataAPI<any> =>
  instance.get(
    `/shopping-backend/api/merchant/wx-pay/applyment/cert-type/list`
  );

// 商务号新增或编辑
export const saveOrUpdate = (data: any): DataAPI<any> =>
  instance.post(
    `/shopping-backend/api/merchant/wx-pay/applyment/saveOrUpdate`,
    data
  );

// 提交审核
export const applymentSubmit = (id: number, data: any): DataAPI<any> =>
  instance.post(
    `/shopping-backend/api/merchant/wx-pay/applyment/submit/${id}`,
    data
  );

// 删除
export const applymentDelete = (id: number): DataAPI<any> =>
  instance.delete(
    `/shopping-backend/api/merchant/wx-pay/applyment/delete/${id}`
  );

// 开户授权
export const applymentAuthorise = (id: number): DataAPI<any> =>
  instance.get(
    `/shopping-backend/api/merchant/wx-pay/applyment/authorise/${id}`
  );

// 商务号详情
export const applymentDetail = (id: number): DataAPI<any> =>
  instance.get(`/shopping-backend/api/merchant/wx-pay/applyment/detail/${id}`);
// 拿系统设置
export const getPositionSetting = (data: any): DataAPI<any> =>
  instance.get(`/shopping-backend/api/merchant/style/get?merchantId=`+data.merchantId);

// 企业注册默认会员等级
export const createMerMemberLevel = ( data: any): DataAPI<any> =>
  instance.post(
    `/c-api/member/tier/default/merchant`,
    data
  );

// 柜组注册默认会员等级
export const createGZMemberLevel = ( data: any): DataAPI<any> =>
  instance.post(
    `/c-api/member/tier/default/shoppe`,
    data
  );

// 组织机构目录树
export const organizationTreeApi1 = (params:any): DataAPI<any> =>
  instance.post(`/auth/system/organization/tree/sort`,params);
// 修改密码
export const changePassWord = (data: any): DataAPI<any> =>
  instance.post("/auth/system/user/passwordReset", data);

// 客户对账单-打印生成结算单
export const printSettlementVoucherApi = (data: any): DataAPI<any> =>
  instance.post(
    "/shopping-backend/api/customerBill/getSettlementBill/"+data.id,
    data
  );
  //企微授权
export const wecomAuth = (code: any, state: any): DataAPI<any> =>
  instance.get(
    `/c-api/mer/getuserdetail?code=${code}&state=${state}`
  );